/**
 * Case note create/update APIs return funding totals but omit `is_expired` (CosFundingResource).
 * Merging without preserving/recomputing `is_expired` breaks expired styling and "(Expired)" labels.
 */
export function computeFundingExpired(endDate) {
  if (!endDate) return false;
  const end = new Date(endDate);
  const today = new Date();
  end.setHours(0, 0, 0, 0);
  today.setHours(0, 0, 0, 0);
  return end.getTime() < today.getTime();
}

export function mergeParticipantFundingFromApi(existingRow, fundingFromApi) {
  if (!fundingFromApi) {
    return existingRow;
  }
  const next = {
    ...existingRow,
    id: fundingFromApi.id,
    uuid: fundingFromApi.uuid,
    contract_id: fundingFromApi.contract_id,
    start_date: fundingFromApi.start_date,
    end_date: fundingFromApi.end_date,
    amount_allocated: fundingFromApi.amount_allocated,
    amount_delivered: fundingFromApi.amount_delivered,
    amount_remaining: fundingFromApi.amount_remaining,
    review_date: fundingFromApi.review_date,
    sign_date: fundingFromApi.sign_date,
    status: fundingFromApi.status,
    total_contract_amount: fundingFromApi.total_contract_amount,
  };
  if (
    fundingFromApi.is_expired !== undefined &&
    fundingFromApi.is_expired !== null
  ) {
    next.is_expired = fundingFromApi.is_expired;
  } else if (next.end_date) {
    next.is_expired = computeFundingExpired(next.end_date);
  }
  return next;
}
